import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-form-accordion-container',
	templateUrl: './form-accordion-container.component.html',
	styleUrls: ['./form-accordion-container.component.scss']
})
export class FormAccordionContainerComponent implements OnInit {
	@Input() title: string;
	@Input() searchButtonText: string;
	@Input() clearFilterButtonText: string;
	@Input() mainIconClass: string;
	@Input() isExpanded: boolean;
	@Input() haveActivatedFilters: boolean;
	@Input() formInvalid: boolean;
	@Input() formId: string;
	@Input() hide: boolean;

	@Output() onExpandEventEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() onSubmitEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();
	@Output() onResetFilterEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();
	translateContext = TranslateContext;

	constructor() {
	}

	ngOnInit() {

	}

	onEnterPress(event: KeyboardEvent): void {
		if (!this.formInvalid) {
		  this.onSubmitEventEmitter.emit(event);
		}
	  }
}

